<template>
    <div>
        <div v-for="(players, statType) in currentStats" class="rounded-xl border border-gdc-gray-200 w-full mb-4 overflow-hidden">
            <div class="w-full flex flex-col md:flex-row px-4 py-2">
                <div class="inline-flex w-full items-center">
                    <h3 class="m-0 mb-2 xl:mb-0 xl:pl-2 capitalize">{{  statType }}</h3>
                </div>
                <div class="flex-col lg:flex-row lg:inline-flex w-full lg:w-[50%] lg:items-center">
                    <h3 class="m-0 pr-2 mb-2 xl:mb-0">Season</h3>
                    <select v-model="currentSeasonIndex" class="select">
                        <option v-for="(item, index) in years" :value="index" selected="selected">
                            {{ item }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="w-full flex-row border-t border-gdc-gray-100 mobile-table">
                <table class="table-bg text-left border-t border-gdc-gray-100 w-[80vh] md:w-full table-fixed">
                    <thead>
                        <tr class="border-b border-gdc-gray-100">
                            <td class="font-bold bg-gdc-gray-100 w-[25%] p-4 py-3 table-sticky">Player</td>
                            <td class="font-bold p-4 py-3 even:bg-white odd:bg-gdc-gray-100" v-for="item in statsHeaders[statType]">{{ item }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(playerStats, PlayerName) in players" class="border-b border-gdc-gray-opaque-200 last:border-b-0">
                            <td class="p-4 py-3 even:bg-white odd:bg-gdc-gray-100 table-sticky w-[50vh] md:w-full">
                                <div class="flex flex-row">
                                    <div  class="w-full xl:flex" v-html="formatPlayerName(PlayerName, position)"></div>
                                </div>
                            </td>
                            <td class="p-4 py-3 even:bg-white odd:bg-gdc-gray-100" v-for="stat in playerStats"> {{ stat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'nfl-player-stats',
    props: {
        stats: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },

        translations: {
            type: Object,
            required: true,
        },
    },
    data: function ()
    {
        return {
            currentSeasonIndex: 0,
            selectedSeason: this.stats[0],
        }
    },

    methods:{

        /**
         *
         * @param playerName
         * @param position
         */
        formatPlayerName(playerName, position)
        {
            let player = playerName.split(' ');
            return `<div class="pr-1">${player[0]}</div> ${player[1]}<span class="text-gdc-gray-450 uppercase pl-1">${position}</span>`;
        }
    },

    computed: {

        years: {
            get: function()
            {
                let years = [];
                for (let index in this.stats)
                {
                    years[index] = this.stats[index].season;
                }

                return years;
            }
        },

        playerList: {
            get: function()
            {
                const playerList = [];

                const players = this.selectedSeason.stats[this.type]
                for (let index in players)
                {
                    playerList.push({
                        'playerName': index,
                        'stats': players[index]
                    });
                }

                return playerList;
            }
        },

        currentStats:{
            get: function()
            {
                return this.selectedSeason.stats[this.type];
            }
        },

        position: {
            get: function()
            {
                let position = null;
                switch (this.type) {
                    case 'quarterback':
                        position = "QB";
                        break;
                    case 'runningback':
                        position = "RB";
                        break;
                    case 'widereceiver':
                        position = "WR";
                        break;
                    case 'tightend':
                        position = "TE";
                        break;
                }
                return position;
            },
        },

        statsHeaders: {
            get: function()
            {
               let headers = {};

               if (this.type === 'quarterback')
               {
                   headers = {
                       'passing': [
                           'ATT',
                           'CMP',
                           'CMP%',
                           'YDS',
                           'AVG',
                           'TD',
                           'LNG',
                       ],
                       'rushing': [
                           'ATT',
                           'YDS',
                           'AVG',
                           'AVG',
                           'TD',
                       ],
                   };
               }
               if (this.type === 'runningback')
               {
                   headers = {
                       'receiving': [
                           'REC',
                           'YDS',
                           'AVG',
                           'TD',
                       ],
                       'rushing': [
                           'ATT',
                           'YDS',
                           'AVG',
                           'TD',
                       ],
                   };
               }

               if (this.type === 'widereceiver')
               {
                   headers = {
                       'receiving': [
                           'REC',
                           'TGTS',
                           'YDS',
                           'AVG',
                           'TD',
                           'LNG',
                       ],
                   };
               }

               if (this.type === 'tightend')
               {
                   headers = {
                       'receiving': [
                           'REC',
                           'TGTS',
                           'YDS',
                           'AVG',
                           'TD',
                           'LNG',
                       ],
                   };
               }

               return headers;
            }
        }
    },

    watch: {

        currentSeasonIndex()
        {
            this.selectedSeason = this.stats[this.currentSeasonIndex]
        },

    }
}
</script>
<style lang="scss" scoped>
.select
{
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill='%23888'%3E%3Cpath d='m0 6 12 12L24 6H0z'/%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3C/svg%3E");
    background-position-x: 95%;
    background-position-y: 50%;
    background-repeat: no-repeat;
    background-size: 10px;
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    padding: 1rem;
    width: 100%;
    border-radius: 10px;
    border: 1px solid rgba(51, 51, 51, 0.25);
}

.table-bg {
    col:first-child {background: #FF0}
    col:nth-child(2n+3) {background: #CCC}
}

@media (min-width: 768px) {
    .flex-name {
        display:flex;
    }
}


@media (max-width: 765px) {

    .mobile-table {
        width: 100%;overflow-y: scroll;
    }

    .table-sticky {
        position: sticky; left: 0; top: 0;
    }
}


</style>
